<section class="fdd-card fdd-block2" [class.fdd-block2--empty]="!timelineDates.length">
  @if (timelineDatesLoading) {
    <div class="fdd-block2__loader" aria-busy="true">
      <app-loading [loading]="true"></app-loading>
    </div>
  }
  <div class="fdd-block2__head">
    <div>
      <div class="fdd-card-title">{{ 'FIELD_DETAILS_V2.TIMELINE_TITLE' | translate }}</div>
      <div class="fdd-legend">
        <span><i class="fdd-dot fdd-dot--bad"></i>{{ 'FIELD_DETAILS_V2.LEGEND_BAD' | translate }}</span>
        <span><i class="fdd-dot fdd-dot--cloud"></i>{{ 'FIELD_DETAILS_V2.LEGEND_EMPTY' | translate }}</span>
        <span><i class="fdd-dot fdd-dot--ok"></i>{{ 'FIELD_DETAILS_V2.LEGEND_OK' | translate }}</span>
      </div>
    </div>
    <button
      pButton
      type="button"
      class="p-button-text"
      (click)="onCalendarClick()"
      [title]="'Select date' | translate"
    >
      <i class="pi pi-calendar"></i>
    </button>
  </div>
  <div class="fdd-timeline-slider">
    @if (timelineDates.length) {
      <button
        type="button"
        class="fdd-timeline-nav"
        (click)="timelineScrollPrev()"
        [attr.aria-label]="'Previous' | translate"
      >
        <i class="pi pi-chevron-left"></i>
      </button>
      <div class="fdd-timeline-viewport" #timelineViewport>
        <div class="fdd-timeline-rail" role="list">
          <div class="fdd-timeline-line" aria-hidden="true"></div>
          @for (d of timelineDates; track trackTimeline($index, d)) {
            <button
              type="button"
              class="fdd-timeline-node"
              role="listitem"
              [class.fdd-timeline-node--active]="isSelectedDay(d)"
              [class.fdd-timeline-node--anomaly]="isAnomalyDay(d)"
              [attr.title]="timelineNodeTitle(d) || null"
              (click)="onDayClick(d)"
            >
              <span class="fdd-timeline-point" [ngClass]="timelineDotClass(d)"></span>
              <span class="fdd-timeline-date-label">{{ d | date: 'dd.MM.yy' }}</span>
            </button>
          }
        </div>
      </div>
      <button
        type="button"
        class="fdd-timeline-nav"
        (click)="timelineScrollNext()"
        [attr.aria-label]="'Next' | translate"
      >
        <i class="pi pi-chevron-right"></i>
      </button>
    } @else {
      <div class="fdd-timeline-empty muted">
        {{ 'FIELD_DETAILS_V2.TIMELINE_EMPTY' | translate }}
      </div>
    }
  </div>
  @if (selectedTimelineDate) {
    <div class="fdd-timeline-selected muted">
      {{ 'FIELD_DETAILS_V2.SELECTED' | translate }}: {{ selectedTimelineDate | date: 'dd.MM.yy' }}
    </div>
  } @else if (!timelineDates.length) {
    <div class="fdd-timeline-selected muted">
      {{ 'FIELD_DETAILS_V2.TIMELINE_NO_SELECTION' | translate }}
    </div>
  }
</section>
